export  const decodeJwt = (token: string) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Invalid JWT token', error);
      return null;
    }
  };
  export const getJwtExpiration = (token: string): Date | null => {
    const decoded = decodeJwt(token);
    if (decoded && decoded.exp) {
      const expirationTime = decoded.exp * 1000; // Convert to milliseconds
      return new Date(expirationTime);
    }
    return null;
  }
  export const getJwtRoles = (token: string): string[] => {
    const decoded = decodeJwt(token);
    if (decoded && decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]) {
      return Array.isArray(decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"])
        ? decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]
        : [decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]];
    }
    return [];
  }

  export const getJwtPermissions = (token: string): string[] => {
    const decoded = decodeJwt(token);
    if (!decoded || decoded.Permissions == null) {
      return [];
    }
    try {
      const raw = decoded.Permissions;
      if (Array.isArray(raw)) {
        return raw;
      }
      if (typeof raw === 'string') {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      }
    } catch {
      return [];
    }
    return [];
  }